
import {AuthorizationFunction} from "./AuthorizationFunction";
import {useUserAuthorizations} from "./context";

/**
 * This hook is intended to insulate callers from a change in the access control mechanism.
 * Currently calling the Authorization Service API.
 *
 * See {@link UserAuthorizationProvider}.
 */
export const useAuthorization = (): AuthorizationFunction => {
  const {isUserAuthorized} = useUserAuthorizations();

  return isUserAuthorized;
};
